import { gql } from "@apollo/client";
import { GAME_FIELDS, SWIPER_CONFIGURATION_FIELDS } from "../fragments";
import { graphql } from "../../gql/gql";

// TODO: use graphql instead of gql
export const GAME_CREATE = gql`
  ${GAME_FIELDS}
  mutation GameCreate($data: GameCreateInput!) {
    gameCreate(data: $data) {
      ...GameFields
      configuration {
        ... on SwiperConfiguration {
          id
        }
        ... on RankifierConfiguration {
          id
        }
        ... on QuickRankConfiguration {
          id
        }
        ... on WordopolisConfiguration {
          id
        }
      }
    }
  }
`;

export const GAME_DELETE = gql`
  ${GAME_FIELDS}
  mutation GameDelete($gameId: String!) {
    gameDelete(gameId: $gameId) {
      ...GameFields
    }
  }
`;

export const GAME_UPDATE = gql`
  ${GAME_FIELDS}
  mutation GameUpdate($gameId: String!, $data: GameUpdateInput!) {
    gameUpdate(gameId: $gameId, data: $data) {
      ...GameFields
    }
  }
`;

export const SWIPER_CONFIGURATION_UPDATE = gql`
  ${SWIPER_CONFIGURATION_FIELDS}
  mutation SwiperConfigurationUpdate($swiperConfigurationId: String!, $data: SwiperConfigurationUpdateInput!) {
    swiperConfigurationUpdate(swiperConfigurationId: $swiperConfigurationId, data: $data) {
      ...SwiperConfigurationFields
    }
  }
`;

export const LEADERBOARD_CONFIGURATION_UPDATE = graphql(`
  mutation LeaderboardConfigurationUpdate(
    $data: LeaderboardConfigurationUpdateInput!
    $leaderboardConfigurationId: String!
  ) {
    leaderboardConfigurationUpdate(data: $data, leaderboardConfigurationId: $leaderboardConfigurationId) {
      nicknameQuestion
      nicknameQuestionColor
      header
      headerColor
      nicknameLabel
      numberOfPlayers
      showTimer
      subheader
      subheaderColor
      tableNicknameLabel
      tableScoreLabel
      tableTimeLabel
      backgroundColor
      backgroundImage {
        id
        name
        url
      }
    }
  }
`);

export const RANKIFIER_CONFIGURATION_UPDATE = graphql(`
  mutation RankifierConfigurationUpdate($data: RankifierConfigurationUpdateInput!, $rankifierConfigurationId: String!) {
    rankifierConfigurationUpdate(data: $data, rankifierConfigurationId: $rankifierConfigurationId) {
      id
      mostQuestion
      leastQuestion
      mostQuestionColor
      leastQuestionColor
      showWelcomePage
      showGameResults
      showFeedbackPage
      cardsPerHand
    }
  }
`);

export const QUICKRANK_CONFIGURATION_UPDATE = graphql(`
  mutation QuickRankConfigurationUpdate($data: QuickRankConfigurationUpdateInput!, $quickRankConfigurationId: String!) {
    quickRankConfigurationUpdate(data: $data, quickRankConfigurationId: $quickRankConfigurationId) {
      id
      question
      showWelcomePage
      showGameResults
      showFeedbackPage
      shuffleCards
    }
  }
`);

export const WORDOPOLIS_CONFIGURATION_UPDATE = graphql(`
  mutation WordopolisConfigurationUpdate(
    $data: WordopolisConfigurationUpdateInput!
    $wordopolisConfigurationId: String!
  ) {
    wordopolisConfigurationUpdate(data: $data, wordopolisConfigurationId: $wordopolisConfigurationId) {
      id
      topic
      difficulty
      numberOfRows
      numberOfColumns
      startText
      showWords
      isTimeLimited
      limitedTime
      showWelcomePage
      showRatingScale
      ratingQuestion
      ratingLeftLabel
      ratingRightLabel
      ratingScaleSize
      boardBackgroundColor
      boardColor
      showLeaderboard
      boardBackgroundImage {
        id
      }
    }
  }
`);

export const WORDOPOLIS_CONFIGURATION_UPDATE_WITH_BOARD = graphql(`
  mutation WordopolisConfigurationUpdateWithBoard(
    $data: WordopolisConfigurationUpdateInput!
    $wordopolisConfigurationId: String!
  ) {
    wordopolisConfigurationUpdate(data: $data, wordopolisConfigurationId: $wordopolisConfigurationId) {
      id
      topic
      difficulty
      numberOfRows
      numberOfColumns
      startText
      showWords
      isTimeLimited
      limitedTime
      showWelcomePage
      showRatingScale
      ratingQuestion
      ratingLeftLabel
      ratingRightLabel
      ratingScaleSize
      boardBackgroundColor
      boardColor
      board
      showLeaderboard
      boardBackgroundImage {
        id
      }
    }
  }
`);

export const TRIVIA_CONFIGURATION_UPDATE = graphql(`
  mutation TriviaConfigurationUpdate($data: TriviaConfigurationUpdateInput!, $triviaConfigurationId: String!) {
    triviaConfigurationUpdate(data: $data, triviaConfigurationId: $triviaConfigurationId) {
      id
      showWelcomePage
      showFeedbackPage
    }
  }
`);

export const GAME_VISUALS_UPDATE = graphql(`
  mutation GameVisualsUpdate($data: GameVisualsUpdateInput!, $gameVisualsId: String!) {
    gameVisualsUpdate(data: $data, gameVisualsId: $gameVisualsId) {
      themeColor
      cardBackImage {
        id
      }
      showIcons
      iconSet
      backgroundColor
      backgroundPositiveColor
      backgroundNegativeColor
      backgroundImage {
        id
      }
    }
  }
`);

export const WELCOME_PAGE_UPDATE = graphql(`
  mutation WelcomePageUpdate($data: WelcomePageUpdateInput!, $welcomePageId: String!) {
    welcomePageUpdate(data: $data, welcomePageId: $welcomePageId) {
      welcomeLine
      welcomeLineColor
      subheading
      subheadingColor
      tagLine
      tagLineColor
      button
      buttonColor
      backgroundColor
      backgroundImage {
        id
      }
      logo {
        id
      }
    }
  }
`);

export const FEEDBACK_PAGE_UPDATE = graphql(`
  mutation FeedbackPageUpdate($data: FeedbackPageUpdateInput!, $feedbackPageId: String!) {
    feedbackPageUpdate(data: $data, feedbackPageId: $feedbackPageId) {
      title
      titleColor
      instructionLine
      instructionLineColor
      textBoxPrompt
      textBoxPromptColor
      submitButton
      submitButtonColor
      backgroundColor
      backgroundImage {
        id
      }
    }
  }
`);

export const GAME_RESULTS_UPDATE = graphql(`
  mutation GameResultsUpdate($data: GameResultsConfigurationUpdateInput!, $gameResultsId: String!) {
    gameResultsUpdate(data: $data, gameResultsId: $gameResultsId) {
      id
      scoreTitle_0_20
      scoreTitle_21_40
      scoreTitle_41_60
      scoreTitle_61_80
      scoreTitle_81_100
      scoreTag_0_20
      scoreTag_21_40
      scoreTag_41_60
      scoreTag_61_80
      scoreTag_81_100
      backgroundColor
      backgroundImage {
        id
      }
    }
  }
`);

export const WORDLE_CONFIGURATION_UPDATE = graphql(`
  mutation WordleConfigurationUpdate($data: WordleConfigurationUpdateInput!, $wordleConfigurationId: String!) {
    wordleConfigurationUpdate(data: $data, wordleConfigurationId: $wordleConfigurationId) {
      id
      showWelcomePage
      showFeedbackPage
      word
      numberOfTries
    }
  }
`);
